const getFullDimensions = (elem) => {
  const { offsetHeight, offsetWidth } = elem;
  const computedStyle = window.getComputedStyle(elem);
  const marginTop = parseInt(computedStyle.getPropertyValue('margin-top'), 10);
  const marginBottom = parseInt(
    computedStyle.getPropertyValue('margin-bottom'),
    10,
  );
  const marginLeft = parseInt(
    computedStyle.getPropertyValue('margin-left'),
    10,
  );
  const marginRight = parseInt(
    computedStyle.getPropertyValue('margin-right'),
    10,
  );
  const paddingTop = parseInt(
    computedStyle.getPropertyValue('padding-top'),
    10,
  );
  const paddingBottom = parseInt(
    computedStyle.getPropertyValue('padding-bottom'),
    10,
  );
  const paddingLeft = parseInt(
    computedStyle.getPropertyValue('padding-left'),
    10,
  );
  const paddingRight = parseInt(
    computedStyle.getPropertyValue('padding-right'),
    10,
  );

  return {
    height: offsetHeight + marginTop + marginBottom,
    width: offsetWidth + marginLeft + marginRight,
    marginTop,
    marginBottom,
    marginLeft,
    marginRight,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
  };
};

export default getFullDimensions;
